/**
 * 繁体中文
 */
export default {
  header: {
    lang: '簡繁切換',
    app: 'APP下載',
    about: '關於我們'
  },
  footer: {
    youth: '青少年安全上網',
    declare: '免責聲明',
    copyright: ' 蘇州馳聲信息科技有限公司 All Rights Reserved.',
    icp: '蘇ICP備14027754號-4',
    browser360: '下載360極速瀏覽器',
    browserqq: '下載QQ瀏覽器'
  },
  Login: {
    loginBody: {
      identity: ['學生', '老師', '家長', '教研'],
      login: '登錄',
      rememberPass: '記住密碼',
      forgetPass: '忘記密碼',
      downloadQR: '掃碼下載APP',
      register: '立即註冊',
      downloadByPhone: '手機掃碼下載',
      studentMobile: '學生移動端',
      teacherMobile: '老師移動端'
    },
    findPwd: {
      title: '找回密碼',
      step: ['確認賬號', '修改密碼', '完成'],
      phone: '手機號',
      phonePH: '請輸入手機號',
      verify: '驗證碼',
      verifyPH: '請輸入手機驗證碼',
      verifyBtn: '獲取驗證碼',
      newPwd: '設置新密碼',
      newPwdPH: '請輸入請密碼',
      newPwd2: '再次輸入新密碼',
      newPwdPH2: '請輸入新密碼',
      next: '下一步',
      relogin: '重新登陸',
      success: '密碼修改成功',
      tips: '溫馨提示：系統僅支持已綁定手機號碼的賬號，找回密碼',
      error: {
        phoneLength: '請輸入11位手機號碼',
        verifyEmpty: '驗證碼不能爲空',
        unregister: '該手機號未注冊',
        verifyErr: '驗證碼錯誤',
        pwdInconsistent: '密碼設置不一致',
        pwdEmpty: '密碼不能爲空'
      }
    },
    register: {
      title: '註冊學生帳號',
      phoneNumber: '手機號',
      captcha: '圖形驗證碼',
      captchaPh: '請輸入圖形驗證碼',
      changeOne: '換一個',
      phoneCode: '手機驗證碼',
      phoneCodePh: '請輸入手機驗證碼',
      getCode: '獲取驗證碼',
      password: '密碼',
      passwordPh: '請輸入密碼',
      certifyPassword: '確認密碼',
      newPasswordPh: '請再次輸入密碼',
      accept: '我已閱讀並接受',
      agreement: '《用戶服務協議》',
      rMsg: '註冊',
      haveOne: '已有帳號?',
      rightNow: '立即登錄',
      error: {
        phoneError: '請輸入11位手機號碼',
        phoneCodeError: '手機驗證碼不正確',
        captchaError: '請輸入4位圖形驗證碼',
        pwdEmpty: '密碼不能爲空',
        pwdInconsistent: '兩次密碼輸入不一致'
      }
    },
    perfect: {
      title: '註冊成功，請完善個人信息',
      name: '姓名：',
      namePh: '請輸入學生姓名',
      sex: '性別：',
      sexDefault: '男',
      sexOther: '女',
      idNumber: '身份證：',
      idNumberPh: '請正確輸入15位或18位身份證號碼',
      area: '所在地區：',
      school: '所在學校：',
      other: '其他',
      schoolMsg: '若下拉菜單中沒有找到你的學校，請在“其他”框輸入學校名稱',
      schoolPh: '請輸入學校名稱',
      categroy: '所在年級：',
      class: '所在班級：',
      teacher: '輔導老師：',
      teacherPh: '請輸入輔導老師名稱',
      teacherPhone: '老師電話：',
      teacherPhonePh: '請輸入輔導老師電話',
      attention: '必填信息(*)提交後不可更改，請謹慎操作！',
      save: '保存',
      error: {
        stuNameErrMsg: '學生名字不能為空',
        idNumberErrMsg: '身份證格式不正確',
        teaNameErrMsg: '老師姓名不能為空',
        teaNumberErrMsg: '輔導老師號碼格式不正確',
        schoolErrMsg: '請選擇學校',
        categoryErrMsg: '請選擇所在年級',
        classErrMsg: '請選擇所在班級',
        areaErrMsg: '請選擇省市區'
      }
    }
  },
  Stu: {
    nav: {
      index: '首頁',
      sync: '同步練習',
      record: '學習記錄',
      bible: '馳聲聽說在線寶典',
      msg: '消息中心',
      info: '個人資料',
      logout: '退出登錄'
    },
    StuIndex: {
      kyzx: {
        title: '口語之星',
        showtipMsg: '本周班級口語作業都在70分以上且排名前三的同學可以上榜哦~'
      },
      bjsy: {
        title: '班級好聲音',
        showtipMsg: '上週班級優質好聲音',
        emptyMsg1: '彙集班級英語好聲音',
        emptyMsg2: '展示英語口語風采',
        change: '換一批'
      },
      bjdt: {
        title: '班級動態',
        emptyMsg1: '瞭解班級學校動態',
        emptyMsg2: '一起努力提高英語成績',
        more: '查看更多'
      }
    }
  },
  backlogList: {
    total: '當前作業',
    workcount: '個',
    over: '離結束剩',
    day: '天',
    hour: '小時',
    min: '分',
    nonwork: '暫無老師佈置的作業',
    recommend: '試一試推薦的學習內容吧',
    btn: {
      viewComplete: '查看已完成作業',
      startwork: '開始作業',
      viewDetail: '查看詳情',
      viewMore: '查看更多'
    }
  },
  lowScore: {
    // 低分集&收藏本
    type: '類型',
    count: '共',
    topic: '道試題',
    empty: '學霸都這樣！一個低分都沒有',
    emptyCollection: '你一個題都還沒有收藏',
    ability: '考察能力',
    knowledge: '知識點',
    difficulty: '難度',
    expand: '收起信息',
    detail: '詳情及解析',
    practice: '練習'
  },
  examPaper: {
    contain: '含',
    paper: '份試卷',
    participates: '人參與',
    btn: {
      practice: '測評',
      report: '報告'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/script/i18n/tw.js